import { render, staticRenderFns } from "./HarmForWhitePollutionView.vue?vue&type=template&id=8c1bb808&scoped=true&"
import script from "./HarmForWhitePollutionView.vue?vue&type=script&lang=js&"
export * from "./HarmForWhitePollutionView.vue?vue&type=script&lang=js&"
import style0 from "./HarmForWhitePollutionView.vue?vue&type=style&index=0&id=8c1bb808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1bb808",
  null
  
)

export default component.exports